import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const el = document.querySelector("#premiumHero");
    if (el && window.bootstrap) {
      new window.bootstrap.Carousel(el, {
        interval: 4200,
        ride: "carousel",
        pause: false,
        wrap: true,
      });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setDone(false);

    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);

      form.reset();

      setTimeout(() => setDone(false), 3500);
    }, 1800);
  };

  return (
    <>
      <style>{`
        .hero-slider {
          height: 90vh;
          position: relative;
        }

        .hero-img {
          width: 100%;
          height: 90vh;
          object-fit: cover;
          filter: brightness(52%);
        }

        .hero-grid {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: grid;
          grid-template-columns: 1.15fr 0.85fr;
          padding: 0 7%;
          align-items: center;
          z-index: 10;
          gap: 40px;
        }

        .hero-left {
          color: white;
          animation: fadeUp 1s ease;
        }

        .hero-title {
          font-size: 58px;
          font-weight: 900;
          line-height: 1.1;
          text-shadow: 0 6px 30px rgba(0,0,0,0.8);
        }

        .hero-sub {
          font-size: 20px;
          opacity: 0.95;
          margin-top: 14px;
        }

        .hero-buttons {
          margin-top: 28px;
        }

        .hero-btn-primary {
          background: #005eff;
          padding: 12px 30px;
          border-radius: 10px;
          border: none;
          color: white;
          font-weight: 700;
          font-size: 16px;
          margin-right: 12px;
          transition: 0.2s ease;
        }

        .hero-btn-primary:hover {
          background: #0045c4;
          transform: translateY(-3px);
        }

        .hero-btn-light {
          background: rgba(255,255,255,0.9);
          padding: 12px 30px;
          border-radius: 10px;
          border: none;
          color: #000;
          font-weight: 700;
          font-size: 16px;
          transition: 0.2s ease;
        }

        .hero-btn-light:hover {
          transform: translateY(-3px);
          background: white;
        }

        .trust-row {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
          margin-top: 25px;
        }

        .trust-badge {
          background: rgba(255,255,255,0.1);
          border: 1px solid rgba(255,255,255,0.2);
          padding: 8px 14px;
          border-radius: 12px;
          backdrop-filter: blur(12px);
          color: white;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        /* RIGHT FORM */
        .hero-form-box {
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(18px);
          border: 1px solid rgba(255,255,255,0.25);
          padding: 28px;
          border-radius: 20px;
          animation: fadeUp 1.2s ease;
          box-shadow: 0 15px 50px rgba(0,0,0,0.4);
        }

        .hero-form-box h4 {
          color: white;
          font-weight: 800;
          margin-bottom: 18px;
          text-align: center;
        }

        .hero-input {
          width: 100%;
          background: rgba(255,255,255,0.92);
          border: none;
          padding: 12px;
          border-radius: 12px;
          margin-bottom: 12px;
          font-size: 15px;
        }

        .hero-submit {
          width: 100%;
          background: #ff3b3b;
          border: none;
          padding: 13px;
          color: white;
          font-weight: 700;
          font-size: 17px;
          border-radius: 12px;
          margin-top: 5px;
          transition: 0.2s ease;
        }

        .hero-submit:hover {
          background: #e21f1f;
          transform: translateY(-3px);
        }

        /* MESSAGE STYLES */
        .hero-msg {
          margin-top: 10px;
          text-align: center;
          font-weight: 600;
        }

        .loading-text {
          color: #fff;
        }

        .success-text {
          color: #00ff9d;
          animation: fadeUp 0.6s ease;
        }

        /* MOBILE */
        @media(max-width: 768px) {
          .hero-slider, .hero-img {
            height: 72vh;
          }

          .hero-grid {
            grid-template-columns: 1fr;
            padding: 0 6%;
            padding-bottom: 40px;
            align-items: flex-end;
            gap: 0px;
          }

          .hero-title {
            font-size: 36px;
          }

          .hero-form-box {
            display: none !important;
          }
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* BACKGROUND SLIDER */}
      <div id="premiumHero" className="carousel slide carousel-fade hero-slider">
        <div className="carousel-inner">
          <div className="carousel-item active"><img src="/slider1.jpg" className="hero-img" /></div>
          <div className="carousel-item"><img src="/slider2.jpg" className="hero-img" /></div>
          <div className="carousel-item"><img src="/slider3.jpg" className="hero-img" /></div>
          <div className="carousel-item"><img src="/slider4.jpg" className="hero-img" /></div>
        </div>

        {/* TEXT + FORM */}
        <div className="hero-grid">

          {/* LEFT CONTENT */}
          <div className="hero-left">
            <h1 className="hero-title">Fast, Secure & Compliant Logistics</h1>
            <p className="hero-sub">
              U.S. based logistics trusted for shipping, freight, warehousing & e-commerce fulfillment.
            </p>

            <div className="hero-buttons">
              <Link to="/services"><button className="hero-btn-primary">Explore Services</button></Link>
              <Link to="/get-quote"><button className="hero-btn-light">Get Quote</button></Link>
            </div>

            <div className="trust-row">
              <div className="trust-badge">🔒 PCI-DSS Secure</div>
              <div className="trust-badge">📦 CBP Compliant</div>
              <div className="trust-badge">🚚 Trusted Carrier Network</div>
              <div className="trust-badge">🇺🇸 Arizona Registered LLC</div>
            </div>
          </div>

          {/* RIGHT FORM */}
          <form className="hero-form-box" onSubmit={handleSubmit}>
            <h4>Quick Quote</h4>

            <input type="text" className="hero-input" required placeholder="Full Name" />
            <input type="text" className="hero-input" required placeholder="Phone Number" />
            <input type="email" className="hero-input" required placeholder="Email Address" />
            <textarea rows="2" className="hero-input" required placeholder="Shipment Details"></textarea>

            <button type="submit" className="hero-submit">
              {loading ? "Please wait..." : "Submit Request"}
            </button>

            {loading && (
              <p className="hero-msg loading-text">Processing your request...</p>
            )}
            {done && (
              <p className="hero-msg success-text">Thank you! We will contact you shortly.</p>
            )}
          </form>

        </div>
      </div>
    </>
  );
}
